import axiosInstance from './axiosInstance';

// Fetch a single exam result
export const fetchExamResults = async (userId) => {
  try {
    const response = await axiosInstance.get(`/api/exam-results/allforuser/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching exam results:', error);
    throw error;
  }
};

// Fetch all exam results 


export const fetchAllExamResults = async () => {
  try {
    const response = await axiosInstance.get('/api/exam-results/');
    return response.data;
  } catch (error) {
    console.error('Error fetching all exam results:', error);
    throw error;
  }
};


export const fetchAllExamResultsInAdmin = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/exam-results/all/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching exam results:', error);
    throw error;
  }
};